<template>
  <transition :name="enabled ? name : ''">
    <slot />
  </transition>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  // transition can be conditionally disabled using this property
  enabled: { type: Boolean, default: true },
  name: {
    type: String as PropType<
      'dropdown' | 'footer' | 'bubble' | 'fade' | 'clear' | 'slide' | 'slide-right'
    >,
    default: 'dropdown',
  },
})
</script>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  @apply opacity-100 overflow-hidden max-h-96 transition-all;

  transition-property: max-height, opacity;
}

.dropdown-enter,
.dropdown-leave-to {
  @apply max-h-0 scale-90 opacity-0;
}

.footer-enter-active,
.footer-leave-active {
  @apply transition-all;

  transition-property: margin-bottom;
}

.footer-enter,
.footer-leave-to {
  @apply -mb-10;
}

.bubble-enter-active,
.bubble-leave-active {
  @apply transition-all;
}

.bubble-enter,
.bubble-leave-to {
  @apply scale-0 opacity-0;
}

.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity;
}

.fade-enter,
.fade-leave-to {
  @apply opacity-0;
}

.slide-enter-active,
.slide-leave-active {
  @apply transition-all;
}

.slide-enter,
.slide-leave-to {
  @apply opacity-0 -translate-y-2;
}

.slide-right-enter-active,
.slide-right-leave-active {
  @apply transition-all;
}

.slide-right-enter,
.slide-right-leave-to {
  @apply opacity-0 -translate-x-8;
}

.clear-enter-active,
.clear-leave-active {
  @apply opacity-100 transition-all;
}

.clear-enter,
.clear-leave-to {
  @apply opacity-0 scale-y-95;
}
</style>
